import i18n from "../i18n";
import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  TextInput,
  Select,
  Textarea,
  NumberInput,
  Group,
  Title,
  Text,
  Divider,
  Grid,
} from "@mantine/core";
import ReactJson from "react-json-view";

import ArrayTable from "./arrayTable";
import { DATA_CURRENCY } from "../data/options";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import { useFormatter } from "../hooks/useFomatter";
import { useForm } from "@mantine/form";
import { useAuthUser } from "react-auth-kit";
import { useForceUpdate } from "@mantine/hooks";

const QuotationChargeSummary = ({ form, name }) => {
  const forceUpdate = useForceUpdate();
  const [formatter] = useFormatter();
  const auth = useAuthUser();

  // Initialize with current form values
  const [total, setTotal] = useState(_.get(form.values, "total") || 0);
  const [costTotal, setCostTotal] = useState(
    _.get(form.values, "costTotal") || 0
  );
  const [discountAmount, setDiscountAmount] = useState(
    _.get(form.values, "discountAmount") || 0
  );

  // Watch for form changes and update local state
  useDeepCompareEffect(() => {
    const newTotal = _.get(form.values, "total") || 0;
    const newCostTotal = _.get(form.values, "costTotal") || 0;
    const newDiscountAmount = _.get(form.values, "discountAmount") || 0;

    // console.log("QuotationChargeSummary: form values changed", {
    //   total: newTotal,
    //   costTotal: newCostTotal,
    //   discountAmount: newDiscountAmount,
    //   previousValues: { total, costTotal, discountAmount },
    // });

    setTotal(newTotal);
    setCostTotal(newCostTotal);
    setDiscountAmount(newDiscountAmount);
    forceUpdate();
  }, [
    form.values.total,
    form.values.costTotal,
    form.values.discountAmount,
    form.values.chargeItems,
  ]);

  // Also initialize on component mount
  useEffect(() => {
    const initialTotal = _.get(form.values, "total") || 0;
    const initialCostTotal = _.get(form.values, "costTotal") || 0;
    const initialDiscountAmount = _.get(form.values, "discountAmount") || 0;

    // console.log("QuotationChargeSummary: initializing", {
    //   total: initialTotal,
    //   costTotal: initialCostTotal,
    //   discountAmount: initialDiscountAmount,
    // });

    setTotal(initialTotal);
    setCostTotal(initialCostTotal);
    setDiscountAmount(initialDiscountAmount);
  }, []);

  const userRole = auth().userRole?.name?.toUpperCase();
  const showProfit =
    !process.env.REACT_APP_DEBIT_NOTE_SHOW_PROFIT_USER_ROLE ||
    process.env.REACT_APP_DEBIT_NOTE_SHOW_PROFIT_USER_ROLE.split(",").includes(
      userRole
    );

  return (
    <>
      <Divider my="xl" />
      {/* Debug info */}
      {/* <div
        style={{
          background: "#f0f0f0",
          padding: "10px",
          marginBottom: "10px",
          fontSize: "12px",
        }}
      >
        Debug: total={total}, costTotal={costTotal}, discountAmount=
        {discountAmount}
      </div> */}
      <Group position="apart">
        <div>
          {showProfit && (
            <>
              <Group position="apart" w={300}>
                <Text size={"xs"}>{i18n.t("Client Payable")}</Text>
                <Title order={3}>
                  {formatter.currency(total - discountAmount)}
                </Title>
              </Group>
              <Group position="apart" w={300}>
                <Text size={"xs"}>{i18n.t("Net Premium")}</Text>
                <Title order={3}>{formatter.currency(costTotal)}</Title>
              </Group>
              <Divider />
              <Group position="apart" w={300}>
                <Text size={"xs"}>{i18n.t("Profit")}</Text>
                <Title
                  order={3}
                  color={
                    total - costTotal - discountAmount > 0 ? "green" : "red"
                  }
                >
                  {formatter.currency(total - costTotal - discountAmount)}
                </Title>
              </Group>
            </>
          )}
        </div>

        <div>
          <Group position="apart" w={300}>
            <Text size={"xs"}>{i18n.t("Total Premium")}</Text>
            <Title order={3}>{formatter.currency(total)}</Title>
          </Group>
          <Group position="apart" w={300}>
            <Text size={"xs"}>Excl. Discount</Text>
            <Title order={3} color={discountAmount > 0 ? "red" : ""}>
              {discountAmount == 0 ? "-" : formatter.currency(-discountAmount)}
            </Title>
          </Group>
          <Divider />
          <Group position="apart" w={300}>
            <Text size={"xs"}>{i18n.t("Client Payable")}</Text>
            <Title order={3}>
              {formatter.currency(total - discountAmount)}
            </Title>
          </Group>
        </div>
      </Group>
    </>
  );
};

export default QuotationChargeSummary;
